module.exports = __webpack_public_path__ + "img/major10.84a87434.png";